import Layout from "@/components/feature/Layout";
import Hero from "./components/Hero";
import HotContent from "./components/HotContent";
import PlotOverview from "./components/PlotOverview";
import CharacterPreview from "./components/CharacterPreview";
import ReviewsPreview from "./components/ReviewsPreview";
import FaqPreview from "./components/FaqPreview";
import CtaAbout from "./components/CtaAbout";
import { faqItems } from "@/mocks/faqItems";

function Home() {
  const homeFaq = faqItems.slice(0, 4);

  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: homeFaq.map((f) => ({
      "@type": "Question",
      name: f.q,
      acceptedAnswer: { "@type": "Answer", text: f.a },
    })),
  };

  const siteSchema = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    name: "嘿咻嘿咻漫画资讯站",
    url: "https://characterz2.github.io/",
    description:
      "嘿咻嘿咻漫画剧情走向与结局分析，角色设定、漫画评价与读者讨论一网打尽。",
  };

  return (
    <Layout>
      <title>嘿咻嘿咻漫画 - 剧情与结局解析、角色设定、读者评价全收录</title>
      <meta
        name="description"
        content="点开即看嘿咻嘿咻漫画剧情走向与结局分析，角色设定、漫画评价与读者讨论一网打尽，帮你快速理清故事脉络，追更不迷路。"
      />
      <meta
        name="keywords"
        content="嘿咻嘿咻漫画,嘿咻嘿咻漫画剧情,嘿咻嘿咻漫画结局,嘿咻嘿咻漫画角色,嘿咻嘿咻漫画评价"
      />
      <link rel="canonical" href="https://characterz2.github.io/" />
      <script type="application/ld+json">{JSON.stringify(siteSchema)}</script>
      <script type="application/ld+json">{JSON.stringify(faqSchema)}</script>

      <Hero />
      <HotContent />
      <PlotOverview />
      <CharacterPreview />
      <ReviewsPreview />
      <FaqPreview />
      <CtaAbout />
    </Layout>
  );
}

export default Home;